// extracted by mini-css-extract-plugin
export var footer = "_oi-5";
export var fulfillmentInput = "_oi-0";
export var shipDateInput = "_oi-1";
export var shipmentModal = "_oi-2";
export var shipmentModalContent = "_oi-3";
export var tableContainer = "_oi-4";